import config from '@config';

import createDataSource from './createDataSource';
import { getDefaultEmptyList, getDefaultListHandler } from './utils';

const BASE_URL = 'getty-images';
const MEDIA_PATHNAME = 'media';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const publish = async (options) => {
    const res = await dataSource.post(`${BASE_URL}`, { json: { imageId: options.id } }).json();

    return dataSource
      .post(MEDIA_PATHNAME, { json: { ...options, fileName: res, type: 'image', copyright: 'Getty Images' } })
      .json();
  };

  return {
    getList: getDefaultListHandler({
      url: BASE_URL,
      dataSource,
    }),
    publish,

    getEmptyList: getDefaultEmptyList,
  };
};
